export default __webpack_public_path__ + "static/media/logo.23d96ec3.png";